<template>
  <div class="wl-school-static-wrpper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">毕业生就业情况统计表（企业）</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>    
    </div>
    <!-- 移动端 -->
    <div class="ph-baisc-head-main">
      <img src="https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/bWwrCnyQdKFJAZ6b.png" alt />
    </div>
    <div class="basic-form-main">
      <table border="0" cellspacing="0" cellpadding="0" class="school-static-table">
        <tr>
          <td colspan="8">
            <div class="table-head-con">毕业生就业情况统计表（企业）</div>
          </td>
        </tr>
        <tr>
          <td class="td-label">单位名称</td>
          <td colspan="3">
            <el-input v-model="unitName"></el-input>
          </td>
          <td colspan="2" class="td-label">疫情期间拟招工时间</td>
          <td colspan="2">
            <el-date-picker v-model="timeValue" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
          </td>
        </tr>
        <tr>
          <td class="td-label">联系人</td>
          <td>
            <el-input v-model="linkPerson"></el-input>
          </td>
          <td class="td-label">电话</td>
          <td>
            <el-input v-model="linkPhone"></el-input>
          </td>
          <td class="td-label">职务</td>
          <td>
            <el-input v-model="post"></el-input>
          </td>
          <td class="td-label">邮箱</td>
          <td>
            <el-input v-model="email"></el-input>
          </td>
        </tr>
      </table>
      <table
        v-for="(item,index) in postData"
        :key="index"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="school-static-table"
        :class="{'lastTable' : index == postData.length - 1}"
      >
        <tr>
          <td class="td-label">岗位名额</td>
          <td>
            <el-input v-model="item.NumberOfPosts" type="number"></el-input>
          </td>
          <td class="td-label">用工需求</td>
          <td>
            <el-input v-model="item.LaborDemand"></el-input>
          </td>
          <td class="td-label">工作内容</td>
          <td>
            <el-input v-model="item.JobContent"></el-input>
          </td>
          <td class="td-label">面向毕业生层次</td>
          <td>
            <el-input v-model="item.ForGraduatesArrangement"></el-input>
          </td>
        </tr>
        <tr>
          <td class="td-label">工作地区</td>
          <td>
            <el-input v-model="item.WorkingArea"></el-input>
          </td>
          <td class="td-label">年薪酬</td>
          <td>
            <el-input v-model="item.YearlySalary"></el-input>
          </td>
          <td class="td-label">保险情况</td>
          <td colspan="3">
            <el-input v-model="item.IsInsure"></el-input>
          </td>
        </tr>
      </table>
      <div class="click-add-line" @click="addLine">
        <i class="wl-icon-tianjia"></i> 点击添加岗位信息行
      </div>
      <div class="submit-table-con" >
        <el-button type="primary" :disabled="isCanSubmit" @click="submitTable">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      unitName: "",
      linkPerson: "",
      linkPhone: "",
      post: "",
      email: "",
      schoolType: "",
      postData: [
        {
          NumberOfPosts: "",
          LaborDemand: "",
          JobContent: "",
          ForGraduatesArrangement: "",
          WorkingArea: "",
          YearlySalary: "",
          IsInsure: ""
        }
      ],
      timeValue: "",
      isCanSubmit:false
    };
  },
  created() {},
  methods: {
    addLine() {
      this.postData.push({
        NumberOfPosts: "",
        LaborDemand: "",
        JobContent: "",
        ForGraduatesArrangement: "",
        WorkingArea: "",
        YearlySalary: "",
        IsInsure: ""
      });
    },
    submitTable() {
      if (this.unitName == "") {
        return this.$message.warning("请输入单位名称");
      }
      if (this.linkPerson == "") {
        return this.$message.warning("请输入联系人");
      }
      if (this.linkPhone == "") {
        return this.$message.warning("请输入联系人电话");
      }
      if (this.postData[0].NumberOfPosts == "") {
        return this.$message.warning("请输入岗位名额");
      }
      let reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
      //   if(!reg.test(this.linkPhone)){
      //      return this.$message.warning('请输入联系人电话');
      //   }
      this.$http
        .post("/api/XOrg/Statistics/editOrAddSchoolEnterprise", {
          companyName: this.unitName,
          recruitmentTime:this.timeValue,
          contacts: this.linkPerson,
          contactsPhone: this.linkPhone,
          job: this.post,
          email: this.email,
          json: JSON.stringify(this.postData),
          type: 2
        })
        .then(res => {
          if (res.code > 0) {
            this.isCanSubmit = true;
            return this.$message.success("提交成功");
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wl-school-static-wrpper {
  height: 100%;
  overflow: auto;
  background: #f0f6ff;
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 46px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .phone-head-main {
    display: none;
    background: #056ef5;
    text-align: center;
    color: #fff;
  }
  .basic-form-main {
    margin: 0 auto;
    margin-top: -325px;
    padding: 20px 0;
    width: 1060px;
    min-height: 400px;
    background: #fff;
  }
  .school-static-table {
    margin: 0 auto;
    width: 1030px;
    border-right: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
    td {
      border-left: 1px solid #999;
      border-top: 1px solid #999;
      text-align: center;
    }
    .el-textarea__inner,
    .el-input__inner {
      border: none;
      font-size: 16px;
      color: #000;
    }
    .el-textarea__inner:focus {
      border: none;
    }
    .el-input__inner:focus {
      border: none;
    }
    .el-input__inner {
      height: 39px;
      line-height: 39px;
    }
    .el-date-editor.el-input {
      width: 100%;
    }
    .table-head-con {
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
    }
    .el-select,
    .el-input-number {
      width: 100%;
    }
    .td-label {
      font-size: 15px;
    }
  }
  .lastTable {
    border-bottom: 1px solid #999;
  }
  .click-add-line {
    padding: 20px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    color: #0155d1;
  }
  .click-add-line:hover {
    color: #0155d1;
  }
  .post-info-con {
    margin: 0 auto;
    width: 1030px;
    .post-label {
      width: 128px;
      height: 41px;
      line-height: 41px;
      text-align: center;
    }
  }
  .submit-table-con {
    margin-top: 30px;
    text-align: center;
  }
  .ph-baisc-head-main {
    display: none;
    img {
      width: 100%;
    }
  }
}
@media only screen and (max-width:700px) {
  .wl-school-static-wrpper {
    height: auto;
    .basic-head-main {
      display: none;
    }
    .ph-baisc-head-main {
      display: block;
    }
    .phone-head-main {
      display: block;
    }
  }
}
</style>